import axios from 'axios'
import { URL } from '../url'

export default async function getCases () {
  const language = navigator.languages[0].split("-")[0] === "es" ? "es" : "en";
  const response = await axios.get(URL + `/confluence/index/${language}`)
  return response
}
